export default __webpack_public_path__ + "static/upkeep-logo-color-light-5c9a02769c54e386369972e92b880fbc.svg";